import React from 'react';

import { LoggedOutEmptyStateImage } from 'features/menu/pages/favorites-page/favorites-card-list/empty-state/images';
import {
  EmptyStateWrapper,
  HeaderText,
  ImageWrapper,
  SubText,
} from 'features/menu/pages/favorites-page/favorites-card-list/empty-state/styled';

import { t } from 'state/intl/translations';

const NoFavoritesEmptyState = () => {
  return (
    <EmptyStateWrapper>
      <ImageWrapper>
        <LoggedOutEmptyStateImage />
      </ImageWrapper>
      <HeaderText>{t('noFavoritesHeader')}</HeaderText>
      <SubText>{t('noFavoritesSubheader')}</SubText>
    </EmptyStateWrapper>
  );
};

export default NoFavoritesEmptyState;
